import React from 'react'
import { ProfileQueryClientProvider, useProfileQuery } from './QueryClient'
import { UserIcon } from '@heroicons/react/24/outline'
import { Toaster } from '~/lib/ui/toast'
import BasicInformation from './BasicInformation'
import KeyStrengths from './KeyStrengths'
import GetToKnowMe from './GetToKnowMe'

const HrPortalProfileEditor = ({ title }) => {
  return (
    <ProfileQueryClientProvider>
      <ProfileEditorInner title={title} />
      <Toaster />
    </ProfileQueryClientProvider>
  )
}
export default HrPortalProfileEditor

const ProfileEditorInner = ({ title }) => {
  const { data, isLoading, error } = useProfileQuery()
  const {
    user,
    updated_at: updatedAt,
    key_strengths: keyStrengths = [],
    get_to_know_me: getToKnowMe = {},
    photo_url: photoUrl,
    ...hrPortalProfile
  } = data || {}

  const keyStrengthsKey = keyStrengths ? keyStrengths.join(',') : 'none'

  if (!isLoading && !error) {
    return (
      <div className="mb-40 w-full font-roboto">
        <PageHeading title={title} />
        <div className="flex w-full flex-col items-center gap-y-12">
          <BasicInformation
            key={updatedAt || 'new_record'}
            user={user}
            hrPortalProfile={hrPortalProfile}
            photoUrl={photoUrl}
          />
          <KeyStrengths
            selectedStrengths={keyStrengths || []}
            key={keyStrengthsKey}
          />
          <GetToKnowMe
            currentData={getToKnowMe}
            key={JSON.stringify(getToKnowMe)}
          />
        </div>
      </div>
    )
  }

  return null
}

const PageHeading = ({ title }) => {
  return (
    <div className="mb-6 flex w-full flex-row items-center gap-x-6">
      <div className="flex size-20 items-center justify-center rounded-2.5xl bg-intoo-blue-light">
        <UserIcon className="size-10" />
      </div>
      <h1 className="font-roboto-slab text-3.5xl font-bold tracking-wide text-intoo-select">
        {title}
      </h1>
    </div>
  )
}
